/**
 * The website is a static SPA (scripts/server.cjs) on a different Azure
 * origin than the Function App — unlike local dev, there is no same-origin
 * proxy for `/api/*` in production, so relative fetch() calls 404 against
 * the static server itself instead of ever reaching the API. Empty locally
 * (Vite's dev proxy in vite.config.js still handles relative `/api/*`
 * there); set to the real API origin at production build time — same
 * pattern dashboard/src/hooks/useAdminApi.js already uses.
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "";
